// Single source of truth for the Web Push VAPID public key.
// Must match the VAPID_PUBLIC_KEY secret used by the send-push-notification edge function.
export const VAPID_PUBLIC_KEY =
  'BKzEExVJ9-LspB_0kLbTCE5ObPQdVTHFe9Qd2ipfGhxmfBGXBNZXWU5zg7_aYKhUlsJqW4vcmYZHy2c9UTSnl14';

export function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export function isIOS(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  return (
    /iPad|iPhone|iPod/.test(ua) ||
    // iPadOS 13+ reports as Mac with touch support
    (navigator.platform === 'MacIntel' && (navigator as any).maxTouchPoints > 1)
  );
}

// True when the PWA runs from the Home Screen (required for push on iOS 16.4+)
export function isStandalone(): boolean {
  if (typeof window === 'undefined') return false;
  return (
    window.matchMedia?.('(display-mode: standalone)').matches === true ||
    (navigator as any).standalone === true
  );
}

// iOS only exposes PushManager inside an installed (standalone) PWA
export function iosNeedsInstall(): boolean {
  return isIOS() && !isStandalone();
}

export function detectPlatform(): string {
  if (isIOS()) return isStandalone() ? 'ios-pwa' : 'ios-safari';
  if (typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent)) {
    return isStandalone() ? 'android-pwa' : 'android-web';
  }
  return isStandalone() ? 'desktop-pwa' : 'desktop-web';
}
